/**
 * BoardHouse — Client-Side Collection Filters
 */
(function () {
  'use strict';

  const FILTER_GROUPS = [
    { label: 'Marca', prefix: 'Marca_' },
    { label: 'Tipo', prefix: 'Tipo_' },
    { label: 'Tamanho', prefix: 'Tamanho_' },
  ];

  const TIPO_ORDER = [
    'Clássica',
    'Premium',

    'Biquilha',
    'Triquilha',
    'Quadriquilha',
    'Quadriquilha / 5 fins',

    'Shortboard',
    'Fish',
    'Mid Length',
    'Funboard',
    'Longboard',
    'Skimboard',
    'Bodyboard',

    'Feminino',
    'Masculino',
    'Infantojuvenil',

    'Longboard Skate',
    'Simulador de Surf',
    'Street',
    'Skate Balance',

    'Bermuda',
    'Lycra',
    'Boné de Surf',
    'Maiôs',
  ];

  function sortValues(prefix, values) {
    if (prefix !== 'Tipo_') {
      return values.slice().sort();
    }

    return values.slice().sort((a, b) => {
      const ia = TIPO_ORDER.indexOf(a);
      const ib = TIPO_ORDER.indexOf(b);

      if (ia !== -1 && ib !== -1) {
        return ia - ib;
      }

      if (ia !== -1) {
        return -1;
      }

      if (ib !== -1) {
        return 1;
      }

      return a.localeCompare(b);
    });
  }

  /*
   * Funções antigas dos filtros customizados.
   * Continuam no arquivo, mas NÃO são executadas.
   */

  function init() {
    const grid =
      document.getElementById(
        'product-grid'
      );

    const sidebar =
      document.getElementById(
        'main-collection-filters'
      );

    if (!grid || !sidebar) {
      return;
    }

    const cards =
      Array.from(
        grid.querySelectorAll(
          'li.grid__item'
        )
      );

    if (!cards.length) {
      return;
    }

    const products =
      cards.map((card) => ({
        card,

        tags:
          (
            card.getAttribute(
              'data-tags'
            ) || ''
          )
            .split(',')
            .map((t) =>
              t.trim()
            )
            .filter(Boolean),
      }));

    let allCollectionTags = [];

    const tagsEl =
      document.getElementById(
        'bh-all-tags'
      );

    if (tagsEl) {
      try {
        allCollectionTags =
          JSON.parse(
            tagsEl.textContent
          );
      } catch (e) {}
    }

    const groups =
      FILTER_GROUPS
        .map((g) => ({
          ...g,

          values:
            sortValues(
              g.prefix,
              [
                ...new Set([
                  ...products.flatMap(
                    (p) =>
                      p.tags
                        .filter(
                          (t) =>
                            t.startsWith(
                              g.prefix
                            )
                        )
                        .map(
                          (t) =>
                            t.replace(
                              g.prefix,
                              ''
                            )
                        )
                  ),

                  ...allCollectionTags
                    .filter(
                      (t) =>
                        t.startsWith(
                          g.prefix
                        )
                    )
                    .map(
                      (t) =>
                        t.replace(
                          g.prefix,
                          ''
                        )
                    ),
                ]),
              ]
            ),
        }))
        .filter(
          (g) =>
            g.values.length > 0
        );

    if (!groups.length) {
      return;
    }

    const active = {};

    groups.forEach((g) => {
      active[g.prefix] =
        new Set();
    });

    const ui =
      buildUI(
        groups,
        active,
        products
      );

    sidebar.insertBefore(
      ui,
      sidebar.firstChild
    );
  }

  function buildUI(
    groups,
    active,
    products
  ) {
    const wrap =
      document.createElement(
        'div'
      );

    wrap.className =
      'bh-filters';

    const title =
      document.createElement(
        'h3'
      );

    title.className =
      'bh-filters__title';

    title.textContent =
      'Filtrar';

    wrap.appendChild(
      title
    );

    groups.forEach(
      (group) => {
        const block =
          document.createElement(
            'div'
          );

        block.className =
          'bh-filter-block';

        const label =
          document.createElement(
            'button'
          );

        label.type =
          'button';

        label.className =
          'bh-filter-label';

        label.innerHTML = `
          <span>${group.label}</span>
          <span class="bh-caret">+</span>
        `;

        label.setAttribute(
          'aria-expanded',
          'true'
        );

        const opts =
          document.createElement(
            'div'
          );

        opts.className =
          'bh-filter-opts';

        group.values.forEach(
          (val) => {
            const row =
              document.createElement(
                'label'
              );

            row.className =
              'bh-filter-row';

            const cb =
              document.createElement(
                'input'
              );

            cb.type =
              'checkbox';

            cb.value =
              val;

            cb.addEventListener(
              'change',
              () => {
                if (
                  cb.checked
                ) {
                  active[
                    group.prefix
                  ].add(val);
                } else {
                  active[
                    group.prefix
                  ].delete(val);
                }

                applyFilters(
                  active,
                  products
                );

                updateClear(
                  wrap,
                  active,
                  groups
                );
              }
            );

            const txt =
              document.createElement(
                'span'
              );

            txt.textContent =
              val;

            row.appendChild(
              cb
            );

            row.appendChild(
              txt
            );

            opts.appendChild(
              row
            );
          }
        );

        label.addEventListener(
          'click',
          () => {
            const open =
              opts.style.display !==
              'none';

            opts.style.display =
              open
                ? 'none'
                : '';

            const caret =
              label.querySelector(
                '.bh-caret'
              );

            if (caret) {
              caret.textContent =
                open
                  ? '+'
                  : '−';
            }

            label.setAttribute(
              'aria-expanded',
              String(!open)
            );
          }
        );

        block.appendChild(
          label
        );

        block.appendChild(
          opts
        );

        wrap.appendChild(
          block
        );
      }
    );

    const clear =
      document.createElement(
        'button'
      );

    clear.type =
      'button';

    clear.className =
      'bh-filter-clear';

    clear.textContent =
      'Limpar filtros';

    clear.style.display =
      'none';

    clear.addEventListener(
      'click',
      () => {
        groups.forEach(
          (g) => {
            active[
              g.prefix
            ].clear();
          }
        );

        wrap
          .querySelectorAll(
            'input[type="checkbox"]'
          )
          .forEach(
            (cb) => {
              cb.checked =
                false;
            }
          );

        clear.style.display =
          'none';

        applyFilters(
          active,
          products
        );
      }
    );

    wrap.appendChild(
      clear
    );

    return wrap;
  }

  function applyFilters(
    active,
    products
  ) {
    let visible = 0;

    products.forEach(
      ({ card, tags }) => {
        const show =
          Object.entries(
            active
          ).every(
            ([prefix, vals]) => {
              if (
                !vals.size
              ) {
                return true;
              }

              return [
                ...vals,
              ].some(
                (v) =>
                  tags.includes(
                    prefix + v
                  )
              );
            }
          );

        card.style.display =
          show
            ? ''
            : 'none';

        if (show) {
          visible++;
        }
      }
    );

    const countEl =
      document.getElementById(
        'ProductCountDesktop'
      );

    if (countEl) {
      if (
        !countEl.dataset.orig
      ) {
        countEl.dataset.orig =
          countEl.textContent
            .trim();
      }

      const total =
        products.length;

      const isFiltered =
        Object.values(
          active
        ).some(
          (s) =>
            s.size > 0
        );

      countEl.textContent =
        isFiltered
          ? `${visible} de ${total} produto${
              total !== 1
                ? 's'
                : ''
            }`
          : countEl.dataset
              .orig;
    }
  }

  function updateClear(
    wrap,
    active,
    groups
  ) {
    const clear =
      wrap.querySelector(
        '.bh-filter-clear'
      );

    if (!clear) {
      return;
    }

    const hasActive =
      groups.some(
        (g) =>
          active[
            g.prefix
          ].size > 0
      );

    clear.style.display =
      hasActive
        ? 'block'
        : 'none';
  }

  /*
   * CSS
   */

  function injectCSS() {
    const old =
      document.getElementById(
        'bh-price-custom-css'
      );

    if (old) {
      old.remove();
    }

    const s =
      document.createElement(
        'style'
      );

    s.id =
      'bh-price-custom-css';

    s.textContent = `
      price-range.facets__price {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      .bh-price-input-wrapper {
        display: block;
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        padding:
          12px
          14px
          16px
          0;

        margin: 0;
      }

      .bh-price-inputs {
        display: flex;
        flex-direction: column;

        gap: 14px;

        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;
      }

      .bh-price-field {
        display: block;

        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;
      }

      .bh-price-field-label {
        display: block;

        margin:
          0
          0
          8px;

        font-family:
          'Roboto',
          sans-serif;

        font-size:
          10px;

        line-height:
          1.2;

        letter-spacing:
          0.12em;

        text-transform:
          uppercase;

        color:
          rgba(
            10,
            22,
            40,
            0.65
          );
      }

      .bh-price-box {
        display: flex;
        align-items: center;

        width: 100%;
        max-width: 100%;
        min-width: 0;

        height: 50px;

        box-sizing:
          border-box;

        border:
          1px solid
          rgba(
            10,
            22,
            40,
            0.28
          );

        background:
          #fff;

        overflow:
          hidden;
      }

      .bh-price-box:focus-within {
        border-color:
          #0A1628;
      }

      .bh-price-currency {
        flex:
          0 0 auto;

        display:
          flex;

        align-items:
          center;

        height:
          100%;

        padding:
          0
          7px
          0
          14px;

        font-family:
          'Roboto',
          sans-serif;

        font-size:
          14px;

        color:
          rgba(
            10,
            22,
            40,
            0.62
          );

        white-space:
          nowrap;
      }

      .bh-price-input {
        flex:
          1 1 0 !important;

        width:
          1px !important;

        min-width:
          0 !important;

        max-width:
          100% !important;

        height:
          48px !important;

        margin:
          0 !important;

        padding:
          0
          12px
          0
          0 !important;

        box-sizing:
          border-box !important;

        border:
          0 !important;

        outline:
          0 !important;

        box-shadow:
          none !important;

        border-radius:
          0 !important;

        background:
          transparent !important;

        font-family:
          'Roboto',
          sans-serif !important;

        font-size:
          16px !important;

        color:
          #0A1628 !important;
      }

      .bh-price-input:hover,
      .bh-price-input:focus,
      .bh-price-input:focus-visible,
      .bh-price-input:active {
        border:
          0 !important;

        outline:
          0 !important;

        box-shadow:
          none !important;

        background:
          transparent !important;
      }

      .bh-price-input::placeholder {
        color:
          rgba(
            10,
            22,
            40,
            0.38
          );

        opacity:
          1;
      }

      .bh-price-error {
        display:
          none;

        width:
          100%;

        margin:
          9px
          0
          0;

        font-family:
          'Roboto',
          sans-serif;

        font-size:
          11px;

        line-height:
          1.4;

        color:
          #9b1c1c;
      }

      /*
       * Não é um <button>.
       * Assim o formulário do tema não consegue
       * tratar este controle como submit.
       */

      .bh-price-apply {
        display:
          flex;

        align-items:
          center;

        justify-content:
          center;

        width:
          100%;

        max-width:
          100%;

        height:
          54px;

        margin:
          16px
          0
          0;

        padding:
          0
          20px;

        box-sizing:
          border-box;

        border:
          1px solid
          #0A1628;

        border-radius:
          0;

        background:
          #071426;

        color:
          #fff;

        cursor:
          pointer;

        user-select:
          none;

        -webkit-user-select:
          none;

        touch-action:
          manipulation;

        font-family:
          'Roboto',
          sans-serif;

        font-size:
          12px;

        line-height:
          1;

        letter-spacing:
          0.14em;

        text-transform:
          uppercase;

        text-align:
          center;
      }

      .bh-price-apply:hover {
        background:
          #fff;

        color:
          #0A1628;
      }

      .bh-price-apply:focus-visible {
        outline:
          2px solid
          #0A1628;

        outline-offset:
          2px;
      }

      @media screen and (max-width: 989px) {
        .mobile-facets__submenu
        price-range.facets__price {
          width:
            100% !important;

          max-width:
            100% !important;

          box-sizing:
            border-box !important;
        }

        .mobile-facets__submenu
        .bh-price-input-wrapper {
          width:
            100% !important;

          max-width:
            100% !important;

          padding:
            18px
            24px
            24px !important;

          box-sizing:
            border-box !important;
        }

        .mobile-facets__submenu
        .bh-price-inputs {
          width:
            100%;

          gap:
            16px;
        }

        .mobile-facets__submenu
        .bh-price-box {
          width:
            100%;

          height:
            52px;
        }

        .mobile-facets__submenu
        .bh-price-input {
          height:
            50px !important;

          font-size:
            16px !important;
        }

        .mobile-facets__submenu
        .bh-price-apply {
          width:
            100%;

          height:
            52px;

          margin-top:
            18px;
        }
      }

      @media screen and (max-width: 480px) {
        .mobile-facets__submenu
        .bh-price-input-wrapper {
          padding:
            16px
            18px
            22px !important;
        }
      }

      @media screen and (max-width: 360px) {
        .mobile-facets__submenu
        .bh-price-input-wrapper {
          padding:
            14px !important;
        }
      }
    `;

    document.head.appendChild(
      s
    );
  }

  /*
   * Converte:
   *
   * 50
   * 50,00
   * 1.500
   * 1.500,00
   * 1500.00
   */

  function parseMoney(value) {
    if (
      value === null ||
      value === undefined
    ) {
      return null;
    }

    let text =
      String(value)
        .trim()
        .replace(
          /R\$/gi,
          ''
        )
        .replace(
          /\s/g,
          ''
        );

    if (!text) {
      return null;
    }

    if (
      text.includes('.') &&
      text.includes(',')
    ) {
      const lastDot =
        text.lastIndexOf('.');

      const lastComma =
        text.lastIndexOf(',');

      if (
        lastComma >
        lastDot
      ) {
        text =
          text
            .replace(
              /\./g,
              ''
            )
            .replace(
              ',',
              '.'
            );
      } else {
        text =
          text.replace(
            /,/g,
            ''
          );
      }
    } else if (
      text.includes(',')
    ) {
      text =
        text.replace(
          ',',
          '.'
        );
    } else if (
      /^\d{1,3}(\.\d{3})+$/.test(
        text
      )
    ) {
      text =
        text.replace(
          /\./g,
          ''
        );
    }

    text =
      text.replace(
        /[^\d.-]/g,
        ''
      );

    const number =
      Number(text);

    if (
      !Number.isFinite(
        number
      )
    ) {
      return null;
    }

    return number;
  }

  function formatMoney(value) {
    return Number(
      value
    ).toLocaleString(
      'pt-BR',
      {
        minimumFractionDigits:
          2,

        maximumFractionDigits:
          2,
      }
    );
  }

  function getMaxPrice(
    maxInput
  ) {
    const possibleValues = [
      maxInput.getAttribute(
        'data-max'
      ),

      maxInput.getAttribute(
        'max'
      ),

      maxInput.getAttribute(
        'placeholder'
      ),
    ];

    for (
      const value
      of possibleValues
    ) {
      const parsed =
        parseMoney(
          value
        );

      if (
        parsed !== null &&
        parsed > 0
      ) {
        return parsed;
      }
    }

    return 10000;
  }

  /*
   * Filtro de preço
   */

  function initPriceInputs() {
    const priceRanges =
      document.querySelectorAll(
        'price-range.facets__price'
      );

    if (
      !priceRanges.length
    ) {
      return;
    }

    priceRanges.forEach(
      (
        priceRange,
        index
      ) => {
        if (
          priceRange.dataset
            .bhPriceReady ===
          '1'
        ) {
          return;
        }

        const nativeMin =
          priceRange.querySelector(
            'input[id*="-GTE"]'
          );

        const nativeMax =
          priceRange.querySelector(
            'input[id*="-LTE"]'
          );

        if (
          !nativeMin ||
          !nativeMax
        ) {
          return;
        }

        const minParam =
          nativeMin.getAttribute(
            'name'
          );

        const maxParam =
          nativeMax.getAttribute(
            'name'
          );

        if (
          !minParam ||
          !maxParam
        ) {
          return;
        }

        const maxPrice =
          getMaxPrice(
            nativeMax
          );

        /*
         * Lê os valores atuais
         * diretamente da URL.
         */

        const currentUrl =
          new URL(
            window.location.href
          );

        const urlMin =
          currentUrl
            .searchParams
            .get(
              minParam
            );

        const urlMax =
          currentUrl
            .searchParams
            .get(
              maxParam
            );

        const currentMin =
          parseMoney(
            urlMin
          );

        const currentMax =
          parseMoney(
            urlMax
          );

        const wrapper =
          document.createElement(
            'div'
          );

        wrapper.className =
          'bh-price-input-wrapper';

        const unique =
          `bh-price-${Date.now()}-${index}`;

        wrapper.innerHTML = `
          <div class="bh-price-inputs">

            <div class="bh-price-field">

              <label
                class="bh-price-field-label"
                for="${unique}-min"
              >
                De
              </label>

              <div class="bh-price-box">

                <span class="bh-price-currency">
                  R$
                </span>

                <input
                  id="${unique}-min"
                  type="text"
                  inputmode="decimal"
                  autocomplete="off"
                  class="bh-price-input bh-price-min-input"
                  placeholder="0,00"
                  aria-label="Preço mínimo"
                >

              </div>

            </div>

            <div class="bh-price-field">

              <label
                class="bh-price-field-label"
                for="${unique}-max"
              >
                Até
              </label>

              <div class="bh-price-box">

                <span class="bh-price-currency">
                  R$
                </span>

                <input
                  id="${unique}-max"
                  type="text"
                  inputmode="decimal"
                  autocomplete="off"
                  class="bh-price-input bh-price-max-input"
                  placeholder="${formatMoney(maxPrice)}"
                  aria-label="Preço máximo"
                >

              </div>

            </div>

          </div>

          <p
            class="bh-price-error"
            role="alert"
          ></p>

          <div
            class="bh-price-apply"
            role="button"
            tabindex="0"
            aria-label="Aplicar filtro de preço"
          >
            Aplicar
          </div>
        `;

        const customMin =
          wrapper.querySelector(
            '.bh-price-min-input'
          );

        const customMax =
          wrapper.querySelector(
            '.bh-price-max-input'
          );

        const applyControl =
          wrapper.querySelector(
            '.bh-price-apply'
          );

        const error =
          wrapper.querySelector(
            '.bh-price-error'
          );

        /*
         * Reexibe os filtros
         * que já estiverem na URL.
         */

        if (
          currentMin !== null &&
          currentMin > 0
        ) {
          customMin.value =
            formatMoney(
              currentMin
            );
        }

        if (
          currentMax !== null &&
          currentMax > 0
        ) {
          customMax.value =
            formatMoney(
              currentMax
            );
        }

        function clearError() {
          error.textContent =
            '';

          error.style.display =
            'none';
        }

        function showError(
          message
        ) {
          error.textContent =
            message;

          error.style.display =
            'block';
        }

        function formatField(
          input
        ) {
          const text =
            input.value.trim();

          if (!text) {
            return;
          }

          const number =
            parseMoney(
              text
            );

          if (
            number === null
          ) {
            return;
          }

          input.value =
            formatMoney(
              number
            );
        }

        /*
         * ÚNICA função responsável
         * por realmente aplicar.
         *
         * Enter, clique desktop e
         * botão mobile chamam isso.
         */

        function applyPrice() {
          clearError();

          const minText =
            customMin.value
              .trim();

          const maxText =
            customMax.value
              .trim();

          const min =
            minText
              ? parseMoney(
                  minText
                )
              : null;

          const max =
            maxText
              ? parseMoney(
                  maxText
                )
              : null;

          if (
            minText &&
            (
              min === null ||
              min < 0
            )
          ) {
            showError(
              'Digite um preço mínimo válido.'
            );

            customMin.focus();

            return;
          }

          if (
            maxText &&
            (
              max === null ||
              max < 0
            )
          ) {
            showError(
              'Digite um preço máximo válido.'
            );

            customMax.focus();

            return;
          }

          if (
            min !== null &&
            min > maxPrice
          ) {
            showError(
              `O preço mínimo não pode passar de R$ ${formatMoney(maxPrice)}.`
            );

            customMin.focus();

            return;
          }

          if (
            max !== null &&
            max > maxPrice
          ) {
            showError(
              `O preço máximo não pode passar de R$ ${formatMoney(maxPrice)}.`
            );

            customMax.focus();

            return;
          }

          if (
            min !== null &&
            max !== null &&
            min > max
          ) {
            showError(
              'O preço mínimo não pode ser maior que o preço máximo.'
            );

            return;
          }

          /*
           * Monta a URL usando exatamente
           * os nomes dos inputs nativos
           * da Shopify.
           */

          const url =
            new URL(
              window.location.href
            );

          /*
           * Remove valores anteriores
           * antes de aplicar os novos.
           */

          url.searchParams.delete(
            minParam
          );

          url.searchParams.delete(
            maxParam
          );

          /*
           * Mínimo:
           * campo vazio = sem mínimo.
           */

          if (
            min !== null &&
            min > 0
          ) {
            url.searchParams.set(
              minParam,
              min.toFixed(2)
            );
          }

          /*
           * Máximo:
           * campo vazio = sem máximo.
           */

          if (
            max !== null &&
            max > 0
          ) {
            url.searchParams.set(
              maxParam,
              max.toFixed(2)
            );
          }

          /*
           * Sempre volta para
           * a primeira página.
           */

          url.searchParams.delete(
            'page'
          );

          /*
           * Faz a navegação para
           * a URL filtrada.
           */

          window.location.assign(
            url.toString()
          );
        }

        /*
         * Enter no mínimo.
         */

        customMin.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key ===
              'Enter'
            ) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();

              applyPrice();
            }
          }
        );

        /*
         * Enter no máximo.
         */

        customMax.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key ===
              'Enter'
            ) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();

              applyPrice();
            }
          }
        );

        /*
         * Clique no APLICAR customizado.
         *
         * Como ele agora é uma DIV,
         * não existe submit automático
         * do formulário.
         */

        applyControl.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            applyPrice();
          },
          true
        );

        /*
         * Suporte de teclado no
         * controle APLICAR.
         */

        applyControl.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key ===
                'Enter' ||
              event.key ===
                ' '
            ) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();

              applyPrice();
            }
          },
          true
        );

        customMin.addEventListener(
          'input',
          clearError
        );

        customMax.addEventListener(
          'input',
          clearError
        );

        customMin.addEventListener(
          'blur',
          () => {
            formatField(
              customMin
            );
          }
        );

        customMax.addEventListener(
          'blur',
          () => {
            formatField(
              customMax
            );
          }
        );

        /*
         * Esconde somente o conteúdo
         * original do filtro de preço.
         */

        Array.from(
          priceRange.children
        ).forEach(
          (child) => {
            child.style.display =
              'none';
          }
        );

        priceRange.appendChild(
          wrapper
        );

        /*
         * MOBILE
         *
         * O tema possui outro botão
         * Aplicar no rodapé do filtro.
         * Fazemos ele chamar a MESMA
         * função applyPrice().
         */

        const mobileDetails =
          priceRange.closest(
            '.mobile-facets__details'
          );

        if (
          mobileDetails
        ) {
          const mobileApply =
            mobileDetails
              .querySelector(
                '.mobile-facets__footer .button--primary'
              );

          if (
            mobileApply
          ) {
            /*
             * Remove o onclick do tema,
             * que apenas fecha o drawer.
             */

            mobileApply.removeAttribute(
              'onclick'
            );

            mobileApply.type =
              'button';

            /*
             * Captura antes dos
             * eventos do tema.
             */

            mobileApply.addEventListener(
              'click',
              (event) => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                applyPrice();
              },
              true
            );
          }
        }

        priceRange.dataset
          .bhPriceReady =
          '1';
      }
    );
  }

  /*
   * Inicialização
   */

  function bhBoot() {
    injectCSS();

    /*
     * NÃO chamar init().
     *
     * Se chamar init(), aparece aquele
     * filtro extra:
     *
     * FILTRAR
     * MARCA
     * TIPO
     * TAMANHO
     */

    initPriceInputs();

    const box =
      document.getElementById(
        'main-collection-filters'
      ) ||
      document.querySelector(
        '.facets-vertical'
      );

    /*
     * A Shopify/Dawn atualiza os filtros
     * via AJAX. Se o HTML for recriado,
     * montamos novamente o campo de preço.
     */

    if (
      box &&
      window.MutationObserver
    ) {
      let timer;

      new MutationObserver(
        () => {
          clearTimeout(
            timer
          );

          timer =
            setTimeout(
              () => {
                initPriceInputs();
              },
              250
            );
        }
      ).observe(
        box,
        {
          childList:
            true,

          subtree:
            true,
        }
      );
    }
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      bhBoot
    );
  } else {
    bhBoot();
  }
})();